import { render, staticRenderFns } from "./AdminApplications.vue?vue&type=template&id=572e8ec5&scoped=true&"
import script from "./AdminApplications.vue?vue&type=script&lang=ts&"
export * from "./AdminApplications.vue?vue&type=script&lang=ts&"
import style0 from "./AdminApplications.vue?vue&type=style&index=0&id=572e8ec5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572e8ec5",
  null
  
)

export default component.exports